import axios, {AxiosHeaders, type AxiosAdapter} from 'axios';
import {requestHost} from './client';

export const NOT_ENOUGH_COINS_ERROR_CODE = 1301;
const adapter:AxiosAdapter = async config => {
  const data = await requestHost({method:(config.method ?? 'get').toUpperCase(),path:config.url ?? '',
    params:config.params,body:config.data});
  return {data,status:200,statusText:'OK',headers:new AxiosHeaders(),config};
};
export const axiosClient = axios.create({adapter});
export const axiosNoAuthClient = axios.create({adapter});
